import { css } from '@emotion/react';

import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { ReactNode } from 'react';

export default function TaskAccordion({
  title,
  children,
}: {
  title: ReactNode;
  children: ReactNode;
}) {
  return (
    <Accordion defaultExpanded={true}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="task-details-content"
        id="task-details-header"
      >
        <div
          css={css`
            padding: 0 8px 0 12px;
            flex-grow: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
          `}
        >
          <Typography component="h1" variant="h6">
            {title}
          </Typography>
          <Typography
            component="h1"
            variant="h6"
            style={{ fontSize: 10, letterSpacing: 1.5 }}
          >
            TASK
          </Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails style={{ display: 'block' }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
}
